
import { ApiService } from '..';

export const PageService = {
    get(slug) {
        return ApiService.get('page', slug);
    }
};